const AccountHeader = ({ user }) => {
  return (
    <div className="mb-6 md:mb-8 p-5 md:p-8 bg-burgundy-600 text-white rounded-2xl shadow-xl relative overflow-hidden">
      {/* Subtle background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-brand-gold/10 rounded-full blur-2xl translate-y-1/4 -translate-x-1/4"></div>
      
      <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-4 md:gap-6">
        <div className="min-w-0">
          <h2 className="text-2xl md:text-3xl font-tajawal font-bold mb-2 tracking-wide drop-shadow-sm">{user.full_name || user.name}</h2>
          <p className="font-cairo text-white/90 drop-shadow-sm break-all">{user.email}</p>
        </div>
      </div>
    </div>
  );
};

export default AccountHeader;
